import { useLayoutEffect, useState } from 'react';

// Espaço vertical da página fora de um elemento: do topo da página até ele, mais o que vem embaixo dele até o fim da
// página (no calendário da Agenda: o rodapé do cartão com o total e a margem de baixo). O CSS faz a altura do elemento =
// altura visível da janela menos este espaço, e ele ocupa o resto da tela.
// Mede de novo quando a página muda de tamanho: largura da janela (a legenda quebra em outra linha), cartões e legenda que
// chegam da API e a volta para o Calendário (active). A altura da janela fica com o CSS (100dvh)
export function useSpaceOutside(pageRef, selector, active) {
  const [space, setSpace] = useState(null);

  useLayoutEffect(() => {
    const page = pageRef.current;
    if (!active || !page) return undefined;

    const measure = () => {
      const target = page.querySelector(selector);
      if (!target) return;
      const box = target.getBoundingClientRect();
      const below = page.getBoundingClientRect().bottom - box.bottom + (parseFloat(getComputedStyle(page).marginBottom) || 0);
      setSpace(Math.round(box.top + window.scrollY + below));
    };
    measure();

    if (typeof ResizeObserver === 'undefined') return undefined;
    // Mede no quadro seguinte: mudar a altura dentro do aviso do ResizeObserver dá o erro "ResizeObserver loop" no console
    let frame = 0;
    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(measure);
    });
    observer.observe(page);
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
    };
  }, [pageRef, selector, active]);

  return space;
}
